import { CLASS_NAMES, PIXEL_NAME } from "../../../utils/constants";
import UI from "../../UI";
import GameObject from "../GameObject";
import Wall from "../Wall";

class Womb extends Wall {
  constructor(boss) {
    // super({
    //   id: "womb",
    //   isRigid: true,
    //   isBreakable: false,
    //   isFlat: true,
    //   isPickable: false,
    //   isCrushable: false,
    //   level: boss.level,
    // });
    super("womb", boss.level);

    this.upperObject = null;
    this.object = null;
    this.boss = boss
  }

  setPosition(coords) {
    super.setPosition(coords);
    this.object = this.level.scene.add
      .rectangle(
        UI.tileToScreen(coords.x),
        UI.tileToScreen(coords.y),
        UI.tileToScreen(1),
        UI.tileToScreen(1),
        0x00ff00
      )
      .setAlpha(0)
      .setOrigin(0, 0);
    // let block = new Wall(PIXEL_NAME.WALL, this.level);
    // block.setPosition(coords);
    this.level.setObjectAt(coords.x, coords.y, this);

    // this.upperObject = this.level.scene.add
    //   .rectangle(
    //     UI.tileToScreen(coords.x),
    //     UI.tileToScreen(coords.y - 1),
    //     UI.tileToScreen(1),
    //     UI.tileToScreen(1),
    //     0x00ff00
    //   )
    //   .setOrigin(0, 0);
    // block = new Wall(PIXEL_NAME.WALL, this.level);
    // block.setPosition({
    //   x: coords.x,
    //   y: coords.y - 1,
    // });
    // this.level.setObjectAt(coords.x, coords.y - 1, block);
  }
}

Womb.className = CLASS_NAMES.WOMB
export default Womb;
